import styled from 'styled-components';
import { Row } from 'components/ui/Grid';
import media from 'utils/media-queries';

export const StyledWrapperRaw = styled(Row)`
  margin-top: 6em;

  ${media.md`
    margin-top: 0;
  `};
`;
